import request from '@/utils/request'

//新增设置
export function retailConfig(data) {
  return request({
    url: `/mg/daohang-basic-api/retailConfig`,
    method: 'put',
    data,
  })
}
//设置详情
export function retailConfigDetail(params) {
  return request({
    url: `/mg/daohang-basic-api/retailConfig/itemList`,
    method: 'get',
    params,
  })
}
